/**
 * PresenceDot — tiny visual indicator (🟢 online / 🟡 idle / ⚪ offline)
 * with an optional pulsing halo on the online state. Consumers pass in
 * the pre-resolved status string; use `usePresenceMap()` to source it.
 *
 * Sizes are intentionally small — the dot is meant to sit next to a
 * name/avatar without dominating the row.
 */
import React from "react";

const STATUS_STYLES = {
    online:  { bg: "bg-emerald-500", ring: "bg-emerald-400", label: "Online" },
    idle:    { bg: "bg-amber-400",   ring: "bg-amber-300",   label: "Idle" },
    offline: { bg: "bg-slate-300",   ring: null,             label: "Offline" },
};

const SIZE_PX = { xs: 6, sm: 8, md: 10 };

export function PresenceDot({ status = "offline", size = "sm", className = "" }) {
    const s = STATUS_STYLES[status] || STATUS_STYLES.offline;
    const px = SIZE_PX[size] || SIZE_PX.sm;
    return (
        <span
            className={`relative inline-flex shrink-0 ${className}`}
            style={{ height: px, width: px }}
            aria-label={s.label}
            title={s.label}
            data-testid={`presence-dot-${status}`}
        >
            {s.ring && (
                <span
                    className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-60 ${s.ring}`}
                />
            )}
            <span className={`relative inline-flex rounded-full ${s.bg}`} style={{ height: px, width: px }} />
        </span>
    );
}
